/*
 * @Date: 2024-12-02 17:52:01
 * @Description:资讯表单配置
 */

import AppInformationMgmtList from '../views/information-form-mgmt-list.vue';
import AppInformationMgmtEdit from '../views/information-form-mgmt-edit.vue';

export const route = [
  {
    path: '/main/industry/information-form-mgmt',
    name: 'main-industry-information-form-mgmt',
    redirect: '/main/industry/information-form-mgmt/list',
    meta: {
      title: '资讯表单配置',
      platFrom: 'industry'
    },
    children: [
      {
        path: '/main/industry/information-form-mgmt/list',
        name: 'main-industry-information-form-mgmt-list',
        meta: {
          title: '资讯管理'
        },
        component: AppInformationMgmtList
      },
      {
        path: '/main/industry/information-form-mgmt/add',
        name: 'main-industry-information-form-mgmt-add',
        meta: {
          parentPath: '/main/industry/information-form-mgmt/list',
          title: '新增资讯'
        },
        component: AppInformationMgmtEdit
      },
      {
        path: '/main/industry/information-form-mgmt/edit',
        name: 'main-industry-information-form-mgmt-edit',
        meta: {
          parentPath: '/main/industry/information-form-mgmt/list',
          title: '编辑资讯'
        },
        component: AppInformationMgmtEdit
      }
    ]
  },
  {
    path: '/main/asp/information-form-mgmt',
    name: 'main-asp-information-form-mgmt',
    redirect: '/main/asp/information-form-mgmt/list',
    meta: {
      title: '资讯管理',
      platFrom: 'asp'
    },
    children: [
      {
        path: '/main/asp/information-form-mgmt/list',
        name: 'main-asp-information-form-mgmt-list',
        meta: {
          title: '资讯管理'
        },
        component: AppInformationMgmtList
      },
      {
        path: '/main/asp/information-form-mgmt/add',
        name: 'main-asp-information-form-mgmt-add',
        meta: {
          parentPath: '/main/asp/information-form-mgmt/list',
          title: '新增资讯'
        },
        component: AppInformationMgmtEdit
      },
      {
        path: '/main/asp/information-form-mgmt/edit',
        name: 'main-asp-information-form-mgmt-edit',
        meta: {
          parentPath: '/main/asp/information-form-mgmt/list',
          title: '编辑资讯'
        },
        component: AppInformationMgmtEdit
      }
    ]
  }
];
